import { Component, Input, OnInit, EventEmitter, Output, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Currency } from '../models/Currency';
import { CreateKaizen } from '../models/Kaizen';
import { CurrencyService } from '../Services/Currency.Service';

@Component({
    selector: 'app-ringi',
    templateUrl: './ringi.component.html',
    styleUrls: ['./ringi.component.css'],
    standalone: false
})
export class RingiComponent implements OnInit, OnChanges {
  CreateKaizenRingi : CreateKaizen = new CreateKaizen();
  @Input() CreateKaizen: CreateKaizen = new CreateKaizen();
  @Output() emitKaizenRingi: EventEmitter<{CreateKaizen:CreateKaizen, isValid: boolean}> = new EventEmitter<{CreateKaizen:CreateKaizen, isValid: boolean}>();

  formRingi!: UntypedFormGroup;
  requiredLegend: string = '* = required field';
  isRingiChecked: boolean = false;
  ringiRequiredYesNo: string = 'No';
  isValid: boolean = true;
  inputNumber: number = 0;
  currencies !: Currency[];
  currenciesLoaded !: boolean;
  constructor(private formBuilder: UntypedFormBuilder,public currencyService: CurrencyService) 
  { 
    this.formRingi = this.formBuilder.group({
    ringiRequired: ['', Validators.required],
    ringiNumber: ['', [Validators.required, Validators.maxLength(200)]],
    investmentAmount: [0, Validators.required],
    currencyID:1
    });}

  ngOnInit() { 
    this.getCurrencies();
  }

  ngOnChanges() 
  {
    if(typeof(this.CreateKaizen.ringiNumber) !== 'undefined')
    { 
      this.isRingiChecked = Number(this.CreateKaizen.ringiNumber) > 0;
      this.ringiRequiredYesNo = this.isRingiChecked ? 'Yes' : 'No';
      this.CreateKaizenRingi.ringiNumber = this.CreateKaizen.ringiNumber;
      this.CreateKaizenRingi.investmentAmount = this.CreateKaizen.investmentAmount;   
      this.CreateKaizenRingi.currencyID = this.CreateKaizen.currencyID;           
      this.formRingi.controls['ringiNumber'].setValue(this.CreateKaizen.ringiNumber);
      this.formRingi.controls['ringiRequired'].setValue(this.isRingiChecked);
      this.formRingi.controls['currencyID'].setValue(this.CreateKaizenRingi.currencyID);
      if(this.CreateKaizen.investmentAmount)
      {
        this.formRingi.controls['investmentAmount'].setValue(new Intl.NumberFormat('en-US').format(this.CreateKaizen.investmentAmount).toString());
      }            
      
      this.emitRingi();
    }
  }

  emitRingi() {
    if (this.isRingiChecked == false) {
      this.isValid = true;
    }
    else {
      if (this.CreateKaizenRingi.ringiNumber == undefined) {
        this.isValid = false;
      }
      else {
        if (this.formRingi.value.investmentAmount != '') {
          this.inputNumber = Number(this.formRingi.value.investmentAmount.replaceAll(',', ''));
        }
        else {
          this.inputNumber = 0;
        }
        if ((this.CreateKaizenRingi.ringiNumber.length > 0 && this.CreateKaizenRingi.ringiNumber.length <= 200) && this.inputNumber > 0) {
          this.isValid = true;
        }
        else {
          this.isValid = false;
        }
      }
    }
    this.emitKaizenRingi.emit({ CreateKaizen: this.CreateKaizenRingi, isValid: this.isValid });
  }
  

  ringiChecked(e: any) 
  {
    this.isRingiChecked = e.target.checked;
    //if there is no ringi then component will always be valid
    if (this.isRingiChecked == false)
    {
      this.formRingi.controls['ringiNumber'].setValue('');
      this.formRingi.controls['investmentAmount'].setValue(0);
      this.formRingi.controls['ringiRequired'].setValue(false);
      this.CreateKaizenRingi.ringiNumber = '';
      this.CreateKaizenRingi.investmentAmount = 0;

      this.isValid = true;
      //this.emitRingi();
    }
    else
    {      
      if(typeof(this.CreateKaizen.ringiNumber) !== 'undefined')
      {
        //if the NAMC is TMMC then default the currency to CAD
          if (this.CreateKaizen.companyID == 1) 
          {
            console.log('this.CreateKaizen.companyID', this.CreateKaizen.companyID);
            console.log('this.CreateKaizenRingi.currencyID', this.CreateKaizenRingi.currencyID);
            this.formRingi.controls['currencyID'].setValue(2);
          }
      }
    }
    this.ringiRequiredYesNo = this.isRingiChecked ? 'Yes' : 'No';
    this.emitRingi();
  }
 
  ringiIdChanged(e: any) 
  {

    if (this.CreateKaizenRingi.ringiNumber != e.target.value) {
      this.CreateKaizenRingi.ringiNumber  = e.target.value;
      if(this.CreateKaizenRingi.ringiNumber.length < 1 || this.CreateKaizenRingi.ringiNumber.length > 200)
      {
        this.isValid = false;
      }
      this.emitRingi();
    }
  }

  invAmountChanged(e: any) {
    if (this.CreateKaizenRingi.investmentAmount != e.target.value) 
    {
      this.CreateKaizenRingi.investmentAmount = e.target.value === "" ? 0 : e.target.value.replaceAll(',', '');
      if (this.CreateKaizenRingi.investmentAmount==0)
      {
        this.isValid = false;
      }
      this.emitRingi();
    }
  }

  ringiNumberKeyUp(event:any)
  {
    if(this.formRingi.controls['ringiNumber'].value.length < 1 && this.isRingiChecked == true)
    {
      this.isValid = false;
      this.emitRingi();
    }
    if (this.isRingiChecked == true 
        && this.isValid == false 
        && (this.CreateKaizenRingi.ringiNumber.length > 0 || this.CreateKaizenRingi.ringiNumber.length <= 200)
        && this.formRingi.controls['investmentAmount'].value.length > 0
       )
    {
      this.isValid = true;
      this.emitRingi();
    }
  }

  CommaFormatted(event: any) {
    // skip for arrow keys 37-40 and decimal point 110 if you leave run with trailing decimal it gets removed in conversion
    if ((event.which >= 37 && event.which <= 40) || event.which == 110) return;

    // format number
    if (this.formRingi.value.investmentAmount) 
    {

      var investmentAmountLength = this.formRingi.value.investmentAmount.length;
      //convert string to a number after removing any commas
      this.inputNumber  = Number(this.formRingi.value.investmentAmount.replaceAll(',', ''));
      //now add commas as needed
      var formattedString = new Intl.NumberFormat('en-US').format(this.inputNumber).toString();
      //set the value 
      this.formRingi.patchValue({ investmentAmount: formattedString });
      if (investmentAmountLength > 0)
      {
        this.CreateKaizenRingi.investmentAmount = this.inputNumber;
        this.emitRingi();
      }
    }
    else if ((this.formRingi.value.investmentAmount == "") && this.isRingiChecked == true)
    {
      this.isValid = false;
      this.emitRingi();
    }

  }

  changeAccountCurrency(e: any) 
  {
     this.CreateKaizenRingi.currencyID = e.target.value;
     this.emitRingi();
  }
  
  getCurrencies(): void {
    this.currencyService.getCurrencies().subscribe(data=> 
      this.currencies = data.data, 
      error => console.log(error), () => this.currenciesLoaded = true); 
  }
}